export enum ErrorType {
  BadRequest = 400,
  NotFound = 404,
  NotAuthorized = 401,
  ServerError = 500,
  Unknown = -1,
  NoError = 0,
}
